import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Paziente } from 'src/app/_interfaces/paziente';
import { environment} from "../../environments/environment";
import {Observable} from "rxjs";
import { CookieService } from "../_services/cookie.service";

@Injectable({
    providedIn: 'root',
})
export class PazienteService {

    private apiURL = environment.apiURL;

    constructor(private http: HttpClient, private cookieService: CookieService) {}

    getPazienti(start: number, limit: number, field: string, order: string, search: string) {
        const url =  this.apiURL + '/pazienti?start=' + start + '&limit=' + limit + '&field=' + field + '&orderby=' + order + '&search=' + search
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    getPazientiAutocomplete(start: number, limit: number, field: string, order: string, search: string) {
        const url =  this.apiURL + '/pazienti?start=' + start + '&limit=' + limit + '&field=' + field + '&orderby=' + order + '&search=' + search + '&dropdown=1'
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    getPazientiDropdown() {
        const url =  this.apiURL + '/pazientidropdown'
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    getPaziente(id: string|null) {
        const url =  this.apiURL + '/pazienti/' + id;
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    createPaziente(paziente: Paziente) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(`${this.apiURL}/pazienti`, paziente, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    updatePaziente(paziente: Paziente) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/pazienti`, paziente, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    deletePaziente(paziente: Paziente) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.delete<any>(`${this.apiURL}/pazienti/` + paziente.id, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    getAnamnesi(paziente_id: number|undefined, dashboard: number = 0)  {
        let url = this.apiURL + '/pazienti/' + paziente_id + '/anamnesi';
        if (dashboard) {
            url = url + '?dashboard=1'
        }
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    updateLingua(paziente_id: number, lingua: string) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/pazienti/lingua`, { id: paziente_id, lingua: lingua }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    getConsensi(paziente_id: string|null)  {
        const url =  this.apiURL + '/pazienti/' + paziente_id + '/consensi';
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    getStoricoConsensi(paziente_id: string|null)  {
        const url =  this.apiURL + '/pazienti/' + paziente_id + '/storicoconsensi';
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    updateConsensi(paziente_id: string|null, consensi: any) {
        let consensi_array: any[] = [];
        for (let i=0; i<consensi.length; i++) {
            consensi_array.push({id: consensi[i].condizione.id, condizione_id: consensi[i].condizione.id, consenso: consensi[i].consenso});
        }
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(this.apiURL + '/pazienti/' + paziente_id + '/consensi', {consensi: consensi_array}, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    getCondizioniMancanti(paziente_id: string|null) {
        const url =  this.apiURL + '/pazienti/' + paziente_id + '/condizionimancanti';
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    setCondizioniMancanti(paziente_id: string|null, consensi: any) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.post<any>(this.apiURL + '/pazienti/' + paziente_id + '/condizionimancanti', {consensi: consensi}, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    getMedici(paziente_id: string|null)  {
        const url =  this.apiURL + '/pazienti/' + paziente_id + '/medici';
        return this.http.get<any>(url,  { withCredentials: true, observe: 'response'})
    }

    updatePrivacyConsulto(paziente_id: number, oscura_consulti: boolean, oscura_anamnesi: boolean) : Observable<HttpResponse<any>> {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        });
        return this.http.put<any>(`${this.apiURL}/pazienti/${paziente_id}/privacy-consulto`, {
            oscura_consulti: oscura_consulti,
            oscura_anamnesi: oscura_anamnesi
        }, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }
}
